import React from 'react';
import PropTypes from 'prop-types';

const DisplayStatusesInfo = ({ name, description }) => {
  return (
    <React.Fragment>
      <div className={'status-name'}>{name}</div>
      <p>{description}</p>
    </React.Fragment>
  );
};

DisplayStatusesInfo.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string
};

export default DisplayStatusesInfo;
